// TODO: Write tests for this file

import * as React from "react";

import { BrowserRouter } from "react-router-dom";
import { useFabricDepCheck } from "../../../hooks/deps";
import { useLogAppVersion } from "../../../hooks/version";

import { FederatedModulesDocsAppEntry } from "./helpers";
import { FederatedModulesDocsHelmet } from "./DocsHelmet";
import { FederatedModulesDocsContainerDrawer } from "./DocsContainerDrawer";
import { FederatedModulesDocsContainerRouter } from "./DocsContainerRouter";

export type FederatedModulesDocsContainerProps = {
  env: typeof process.env;
  entries: FederatedModulesDocsAppEntry[];
};

export const FederatedModulesDocsContainer: React.FC<
  FederatedModulesDocsContainerProps
> = ({ env, entries }) => {
  useLogAppVersion(env);
  useFabricDepCheck(env);

  return (
    <>
      <FederatedModulesDocsHelmet />
      <BrowserRouter>
        <FederatedModulesDocsContainerDrawer entries={entries} />
        <FederatedModulesDocsContainerRouter entries={entries} />
      </BrowserRouter>
    </>
  );
};
